module.exports = __webpack_public_path__ + "static/img/template_img_06.a6067a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/template_img_06.jpg
// module id = 396
// module chunks = 0